import { render, staticRenderFns } from "./PostExplainModal.vue?vue&type=template&id=6ae8ccd0&scoped=true"
import script from "./PostExplainModal.vue?vue&type=script&lang=js"
export * from "./PostExplainModal.vue?vue&type=script&lang=js"
import style0 from "./PostExplainModal.vue?vue&type=style&index=0&id=6ae8ccd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8ccd0",
  null
  
)

export default component.exports